import { render, staticRenderFns } from "./AIAssessment_v2.vue?vue&type=template&id=092b3695&scoped=true&"
import script from "./AIAssessment_v2.vue?vue&type=script&lang=js&"
export * from "./AIAssessment_v2.vue?vue&type=script&lang=js&"
import style0 from "./AIAssessment_v2.vue?vue&type=style&index=0&id=092b3695&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b3695",
  null
  
)

export default component.exports